<!-- ? Under a minute -->
<p class="text-[.71rem] sm:text-xs" *ngIf="isMinutes && objectMinutes <= 0" [ngClass]="{
    'text-gray-500': isBookActivity,
    'text-green-600': isBookdetail,
    'text-green-500': isBookProgress,
    'text-lg md:text-xl font-medium': isBookProgress,
    'text-[.71rem] sm:text-xs text-gray-400': !isBookProgress
  }">
  لحظاتی پیش
</p>

<!-- ? Under a houre -->
<p class="text-[.71rem] sm:text-xs" *ngIf="isMinutes && objectMinutes > 0" [ngClass]="{
    'text-gray-500': isBookActivity,
    'text-green-600': isBookdetail,
    'text-green-500': isBookProgress,
    'text-lg md:text-xl font-medium': isBookProgress,
    'text-[.71rem] sm:text-xs text-gray-400': !isBookProgress
  }">
  {{ objectMinutes }} دقیقه پیش
</p>

<!-- ? under 24 houres -->
<p class="text-[.71rem] sm:text-xs" *ngIf="isHour && objectHours < 24" [ngClass]="{
    'text-gray-500': isBookActivity,
    'text-green-600': isBookdetail,
    'text-green-500': isBookProgress,
    'text-lg md:text-xl font-medium': isBookProgress,
    'text-[.71rem] sm:text-xs text-gray-400': !isBookProgress
  }">
  {{ objectHours }} ساعت پیش
</p>

<!-- ? yesterday -->
<p class="text-[.71rem] sm:text-xs" *ngIf="isDay && objectDay == 1" [ngClass]="{
    'text-gray-500': isBookActivity,
    'text-green-600': isBookdetail,
    'text-green-500': isBookProgress,
    'text-lg md:text-xl font-medium': isBookProgress,
    'text-[.71rem] sm:text-xs text-gray-400': !isBookProgress
  }">
  دیروز
</p>

<!-- ? this week (1 to 7 days) -->
<p class="text-[.71rem] sm:text-xs" *ngIf="isDay && objectDay > 1  && objectDay <= 7 && !isWeek" [ngClass]="{
    'text-gray-500': isBookActivity,
    'text-green-600': isBookdetail,
    'text-green-500': isBookProgress,
    'text-lg md:text-xl font-medium': isBookProgress,
    'text-[.71rem] sm:text-xs text-gray-400': !isBookProgress
  }">
  {{ objectDay }} روز پیش
</p>

<!-- ? more than 7 days -->
<p class="text-[.71rem] sm:text-xs" *ngIf="objectDay > 7 && objectDay <= 30" [ngClass]="{
    'text-gray-500': isBookActivity,
    'text-green-600': isBookdetail,
    'text-green-500': isBookProgress,
    'text-lg md:text-xl font-medium': isBookProgress,
    'text-[.71rem] sm:text-xs text-gray-400': !isBookProgress
  }">
  {{ date | jalali }}
  -
  <span class="text-gray-400 text-[.71rem] sm:text-xs">
    {{date| jalaliTimeWithoutSecound}}
  </span>
</p>

<!-- ? this mounth -->
<p class="text-[.71rem] sm:text-xs" *ngIf="isMounth && !isYear" [ngClass]="{
    'text-gray-500': isBookActivity,
    'text-green-600': isBookdetail,
    'text-green-500': isBookProgress,
    'text-lg md:text-xl font-medium': isBookProgress,
    'text-[.71rem] sm:text-xs text-gray-400': !isBookProgress
  }">
  {{ date | jalali }}
  -
  <span class="text-gray-400 text-[.71rem] sm:text-xs">
    {{date| jalaliTimeWithoutSecound}}
  </span>
</p>

<!-- ? befor this year -->
<p class="text-[.71rem] sm:text-xs" *ngIf="isYear" [ngClass]="{
    'text-gray-500': isBookActivity,
    'text-green-600': isBookdetail,
    'text-green-500': isBookProgress,
    'text-lg md:text-xl font-medium': isBookProgress,
    'text-[.71rem] sm:text-xs text-gray-400': !isBookProgress
  }">
  {{ date | jalali }}
  -
  <span class="text-gray-400 text-[.71rem] sm:text-xs">
    {{date| jalaliTimeWithoutSecound}}
  </span>
</p>